import { Button, Icon, Modal, Spacer, Table, TextGroupMedium } from "@cd2/components"
import { H2, P } from "@cd2/text/build/es6"
import React from "react"
import { brandColors, themeColors } from "../../Components/EOSThemeProvider"
import { icons } from "../../constants/icons"
import { useConfirmation } from "../../hooks/useConfirmation"
import { IItem } from "./quoteOrderUtils"
import { ConfirmCancelButtons } from "../../Components/Buttons/ConfirmCancelButtons"

export function useAlertMinimumMargin() {
  return useConfirmation<
    { items: IItem[]; minMargin: number; status: "warning" | "error" },
    boolean
  >(({ onResolve, data }) => {
    const header =
      data.status === "error"
        ? `Cannot save ${data.items.length} items`
        : `There are ${data.items.length} items with warnings`
    return (
      <Modal
        render={() => (
          <TextGroupMedium
            heading={
              <H2>
                <Icon
                  icon={icons.alert}
                  color={data.status === "error" ? brandColors.blaze : themeColors.orange}
                  swapOpacity
                />{" "}
                {header}
              </H2>
            }
            body={
              <React.Fragment>
                <Spacer />
                {data.status === "error" ? (
                  <React.Fragment>
                    <P>
                      Cannot save the items listed as they are below the minimum margin allowed of{" "}
                      {data.minMargin}%.
                    </P>
                    <P>
                      Please increase the margin or remove the following items and ask a user who
                      has permission to save items below the minimum margin to add this product.
                    </P>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <P>The items listed are below the minimum margin of {data.minMargin}%.</P>
                  </React.Fragment>
                )}
                <Spacer />

                <Table data={data.items}>
                  <Table.DataColumn heading="Product" field="stock_code" />
                  <Table.DataColumn heading="Margin" field="markUp" />
                </Table>

                <Spacer />
                <div>
                  {data.status === "error" ? (
                    <Button onClick={() => onResolve(true)}>Confirm</Button>
                  ) : (
                    <ConfirmCancelButtons
                      onConfirm={() => onResolve(true)}
                      onCancel={() => onResolve(false)}
                    />
                  )}
                </div>
              </React.Fragment>
            }
          />
        )}
        isOpen
      />
    )
  })
}
